import React from 'react'
import cx from 'classnames'
import { Link } from 'react-router-dom'
import useMobileBreakpoint from '@scentregroup/shared/helpers/use-mobile-breakpoint'
import { ICategory } from '../../types/marketplace-categories'
import { generatePathForCategoryIdPath } from '../../lib/marketplace-categories'
import trackMkpEvents, { labels } from '../../lib/market-place-track-event'
import style from './index.module.scss'

export interface ICategoryList {
  category: ICategory
  search: string | undefined
  basePath: string
}

export const CategoryList: React.FunctionComponent<
  React.PropsWithChildren<ICategoryList>
> = ({ category, search, basePath }) => {
  const isMobile = useMobileBreakpoint()

  return (
    <ol>
      {category?.children.map(category => (
        <li
          key={category.title}
          className={cx(style.categoryLink, {
            [style.smallCategoryLink]: isMobile,
          })}
        >
          <Link
            to={{
              pathname: generatePathForCategoryIdPath(
                basePath,
                category.path.map(cpe => cpe.code)
              ),
              search,
            }}
            onClick={() =>
              trackMkpEvents.selected(
                labels.createProductCategory(category.title)
              )
            }
          >
            {category.title}
          </Link>
        </li>
      ))}
    </ol>
  )
}
